<template>
  <a-drawer
    :title="`${edit ? '编辑' : '批量新增'}`"
    placement="right"
    :closable="false"
    :maskClosable="false"
    @close="() => changeVisible(false)"
    v-model:visible="siteBarVisible"
    width="500"
  >
    <div v-if="edit" class="df mb20">
      <div class="w120">站点：{{ postParams.siteName }}</div>
      <div class="w120">终端：{{ postParams.terminalName }}</div>
      <div class="w120">月份：{{ postParams.month }}</div>
    </div>
    <div v-if="!edit">
      <div class="mb10">站点</div>
      <div class="mb14">
        <a-checkbox-group
          :disabled="edit"
          v-model:value="postParams.siteIds"
          class="acg"
        >
          <a-checkbox :value="item.id" v-for="(item, key) in sites" :key="key">
            <a-tooltip>
              <template #title>{{ item.name }}</template>
              <div class="ellipsis">{{ item.name }}</div>
            </a-tooltip>
          </a-checkbox>
        </a-checkbox-group>
      </div>
      <div class="mb10">终端</div>
      <div class="mb14">
        <a-checkbox-group
          :disabled="edit"
          v-model:value="postParams.terminalIds"
          class="acg"
        >
          <a-checkbox
            :value="item.value"
            v-for="(item, key) in terminalOptions"
            :key="key"
            >{{ item.label }}</a-checkbox
          >
        </a-checkbox-group>
      </div>
      <div class="mb10">月份</div>
      <div class="mb14">
        <a-checkbox-group
          :disabled="edit"
          v-model:value="postParams.months"
          class="acg"
        >
          <a-checkbox
            :value="item.value"
            v-for="(item, key) in [...monthOptions]"
            :key="key"
            >{{ item.label }}</a-checkbox
          >
        </a-checkbox-group>
      </div>
    </div>
    <div class="mb10">主商品二级类目：</div>
    <div class="mb14">
      <a-cascader
        :disabled="edit"
        style="width: 440px;"
        v-model:value="postParams.mainSkcCategory"
        :options="cascaderOptions"
        :field-names="fieldNames"
        placeholder="请选择"
      />
    </div>
    <div class="mb10">坑位1</div>
    <div class="mb14" style="width: 440px;">
      <a-tree-select
        class="w300"
        v-model:value="categories1"
        style="width: 100%"
        :tree-data="cascaderOptions"
        tree-checkable
        allow-clear
        :show-checked-strategy="SHOW_PARENT"
        :fieldNames="fieldNames"
        search-placeholder="请选择"
      />
    </div>
    <div class="mb10">坑位2</div>
    <div class="mb14" style="width: 440px;">
      <a-tree-select
        class="w300"
        v-model:value="categories2"
        style="width: 100%"
        :tree-data="cascaderOptions"
        tree-checkable
        allow-clear
        :show-checked-strategy="SHOW_PARENT"
        :fieldNames="fieldNames"
        search-placeholder="请选择"
      />
    </div>
    <div class="mb10">坑位3</div>
    <div class="mb14" style="width: 440px;">
      <a-tree-select
        class="w300"
        v-model:value="categories3"
        style="width: 100%"
        :tree-data="cascaderOptions"
        tree-checkable
        allow-clear
        :show-checked-strategy="SHOW_PARENT"
        :fieldNames="fieldNames"
        search-placeholder="请选择"
      />
    </div>
    <div class="mb10">坑位4</div>
    <div class="mb14" style="width: 440px;">
      <a-tree-select
        class="w300"
        v-model:value="categories4"
        style="width: 100%"
        :tree-data="cascaderOptions"
        tree-checkable
        allow-clear
        :show-checked-strategy="SHOW_PARENT"
        :fieldNames="fieldNames"
        search-placeholder="请选择"
      />
    </div>
    <div class="mb10">坑位5</div>
    <div class="mb100" style="width: 440px;">
      <a-tree-select
        class="w300"
        v-model:value="categories5"
        style="width: 100%"
        :tree-data="cascaderOptions"
        tree-checkable
        allow-clear
        :show-checked-strategy="SHOW_PARENT"
        :fieldNames="fieldNames"
        search-placeholder="请选择"
      />
    </div>
    <div class="siderFooter">
      <div>
        <a-button
          type="default"
          class="mr10"
          @click="() => changeVisible(false)"
          >取消</a-button
        >
        <!-- 编辑保存 -->
        <a-button v-if="edit" type="primary" @click="modify" class="mr10"
          >保存</a-button
        >

        <!-- 批量新保存 -->
        <a-button v-if="!edit" type="primary" @click="repeatTest" class="mr10"
          >保存</a-button
        >
      </div>
    </div>
  </a-drawer>
</template>
<script>
import { inject, toRefs } from 'vue'
import { TreeSelect } from 'ant-design-vue'
export default {
  setup() {
    return {
      SHOW_PARENT: TreeSelect.SHOW_PARENT,
      ...toRefs(inject('initState'))
    }
  }
}
</script>
<style scoped>
.ellipsis {
  width: 80px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.acg {
  display: flex;
  flex-wrap: wrap;
}

.siderFooter {
  width: 100%;
  padding: 10px 0;
  background: #ffffff;
  border-top: 1px solid #ddd;
  position: absolute;
  bottom: 0;
  left: 0;
  text-align: right;
}
</style>
<style>
.ant-checkbox-group.acg .ant-checkbox-wrapper {
  margin-left: 8px;
}
</style>
